import { Controller } from "@hotwired/stimulus"
import debounce from "lodash/debounce"

export default class extends Controller {
  static targets = ["input", "results"]
  static values = {
    url: String,
    minLength: { type: Number, default: 3 }
  }

  connect() {
    this.check = debounce(this.check.bind(this), 500, { leading: true });
  }

  check() {
    const query = this.inputTarget.value.trim()
    if (query.length < 3) return this.clear() // Don't check if less than 3 characters

    fetch(`${this.urlValue}?query=${encodeURIComponent(query)}`)
      .then(response => {
        if (!response.ok) {
          console.warn("Duplicate check request failed:", response.status)
          return ""
        }
        return response.text()
      })
      .then(html => {
        this.clear()
        if (!html) return
        this.resultsTarget.innerHTML = html
      })
  }

  clear() {
    this.resultsTarget.innerHTML = ""
  }
}
